import {MI} from "../init.js";
import {Storm} from "./Storm";
import {copyArray, getRandomInt, shuffleArray} from "../../framework/src/helpers";
import {arrayCircleGetElement} from "../utils/helpers";

/**
 * @constructor
 * @extends {Storm}
 * @param {MadnesGroup} group
 * @returns {StormNormal}
 */
export function StormNormal(group) {
    Storm.call(this, group);

    /** @type {number} */
    this._delayFrom = 0;
    /** @type {number} */
    this._delayTo = 0;
}

StormNormal.prototype = Object.create(Storm.prototype);
StormNormal.prototype.constructor = StormNormal;

StormNormal.prototype.create = function(count, delayFrom, delayTo) {

    this._delayFrom = delayFrom;
    this._delayTo = delayTo;

    var flashNums = shuffleArray(copyArray(Storm.flashNumbers));

    for(var i = 0; i < count; i++) {
        var flashNum = arrayCircleGetElement(flashNums, i);

//		this._flashes[i] = MI.addImg(0, 0, "storm_0" + flashNum);
//		this._flashes[i].setAlpha(0);
//		this._flashes[i].setAnchor(0.5, 0);
//		this._flashes[i].setVisible(false);
//
//		var light = MI.addImg(0, 0, "storm_light").setAnchor(0.5, 0);
//		this._flashes[i].addChild(light);

        this._flashes[i] = MI.addImg(0, 0, "storm_light"); //.setAnchor(0, 0);
        this._flashes[i].setAlpha(0);
        this._flashes[i].setVisible(false);

        this._flashes[i]["_flash"] = MI.addImg(0, 0, "storm_0" + flashNum);
        this._flashes[i]["_flash"].setAnchor(0.5, 0);
        this._flashes[i].addChild(this._flashes[i]["_flash"]);

        this._reinitFlashPos(this._flashes[i]["_flash"]);

        this._group.add(this._flashes[i]);
    }
};

StormNormal.prototype.play = function() {
    var _self = this;
    this._isRunning = true;

    for(var i = 0; i < this._flashes.length; i++) {

//		var prom = new Promise(function(res) {
//			_self._flashes[i]['_stormResolver'] = res;
        _self._loopFlash(_self._flashes[i]);
//		});

//		_self._flashesPromises.push(prom);
    }
};

/**
 * @param {MadnesObject} flash
 */
StormNormal.prototype._loopFlash = function(flash) {

    var _self = this;

    if(!_self._isRunning) {
        return;
    }

    var timer = MI.createTimer().add(function() {

            var flashAnim = _self._playFlashAnim(flash).then(function() {
                _self._setRandTexture(flash['_flash']);
                _self._reinitFlashPos(flash['_flash']);
                _self._loopFlash(flash);
            });

            _self._flashesPromises.push(flashAnim);

        },
        getRandomInt(this._delayFrom, this._delayTo));

    this._flashesTimers.push(timer);
};

/**
 * @param {MadnesObject} flash
 * @returns {undefined}
 */
StormNormal.prototype._reinitFlashPos = function(flash) {

    var pos = this._getFlashPos(flash);

    flash.setPosX(pos['posX']);
    flash.setPosY(pos['posY']);
    flash.setScale(pos['scaleX'], pos['scaleY']);
};